import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Juan', 'Carlos', 'Miguel', 'Roberto', 'Daniel', 'Pedro', 'José', 'Luis', 'Fernando', 'Jorge', 'Martín', 'Lucas', 'Matías', 'Nicolás', 'Gustavo'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Tucumán', 'Neuquén', 'Bahía Blanca'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 5000);
    // Interval every 12 seconds
    const interval = setInterval(showNotification, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-272">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-50 bg-white border-l-4 border-green-500 shadow-lg rounded-r-lg p-4 max-w-sm flex items-center gap-3" data-id="element-273">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-274">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-275" />
          </div>
          <div data-id="element-276">
            <p className="text-sm font-medium text-gray-900" data-id="element-277">
              <span className="font-bold" data-id="element-278">{notification.name}</span> de{' '}
              {notification.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-279">
              acaba de comprar La Biblia del Constructor
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-280">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}